// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"337":"f14f0c89","803":"cee49701"}[chunkId] + ".chunk.css";
};